import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Alert,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import { getAdminProfile, updateAdminProfile } from "../../slices/thunks";
import avatar from "../../assets/images/users/avatar-1.jpg";
import { createSelector } from "reselect";
import { toast } from "react-toastify";
import ImageCropper from "../../Components/Common/ImageCropper";
import { User } from "react-feather";

const UserProfile = () => {
  const dispatch = useDispatch();

  const selectProfileState = (state) => state;

  const profileSelector = createSelector(selectProfileState, (state) => ({
    user: state.Aprofile.user,
    loading: state.Aprofile.loading,
    error: state.Aprofile.error,
  }));

  const { user, loading, error } = useSelector(profileSelector);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobileNo: "",
    address: "",
    signature: "",
    signatureFile: null,
    bankName: "",
    branchName: "",
    ifscCode: "",
    accountNo: "",
    state: "",
    stateCode: "",
    saCode: "",
  });

  const [originalData, setOriginalData] = useState({});
  const [showSignatureCropper, setShowSignatureCropper] = useState(false);
  const [signatureSrc, setSignatureSrc] = useState(null);

  const indianStates = [
    { label: "Jammu and Kashmir", value: "Jammu and Kashmir", code: "01" },
    { label: "Himachal Pradesh", value: "Himachal Pradesh", code: "02" },
    { label: "Punjab", value: "Punjab", code: "03" },
    { label: "Chandigarh", value: "Chandigarh", code: "04" },
    { label: "Uttarakhand", value: "Uttarakhand", code: "05" },
    { label: "Haryana", value: "Haryana", code: "06" },
    { label: "Delhi", value: "Delhi", code: "07" },
    { label: "Rajasthan", value: "Rajasthan", code: "08" },
    { label: "Uttar Pradesh", value: "Uttar Pradesh", code: "09" },
    { label: "Bihar", value: "Bihar", code: "10" },
    { label: "Sikkim", value: "Sikkim", code: "11" },
    { label: "Arunachal Pradesh", value: "Arunachal Pradesh", code: "12" },
    { label: "Nagaland", value: "Nagaland", code: "13" },
    { label: "Manipur", value: "Manipur", code: "14" },
    { label: "Mizoram", value: "Mizoram", code: "15" },
    { label: "Tripura", value: "Tripura", code: "16" },
    { label: "Meghalaya", value: "Meghalaya", code: "17" },
    { label: "Assam", value: "Assam", code: "18" },
    { label: "West Bengal", value: "West Bengal", code: "19" },
    { label: "Jharkhand", value: "Jharkhand", code: "20" },
    { label: "Odisha", value: "Odisha", code: "21" },
    { label: "Chhattisgarh", value: "Chhattisgarh", code: "22" },
    { label: "Madhya Pradesh", value: "Madhya Pradesh", code: "23" },
    { label: "Gujarat", value: "Gujarat", code: "24" },
    { label: "Daman and Diu", value: "Daman and Diu", code: "25" },
    {
      label: "Dadra and Nagar Haveli",
      value: "Dadra and Nagar Haveli",
      code: "26",
    },
    { label: "Maharashtra", value: "Maharashtra", code: "27" },
    {
      label: "Andhra Pradesh (Old)",
      value: "Andhra Pradesh (Old)",
      code: "28",
    },
    { label: "Karnataka", value: "Karnataka", code: "29" },
    { label: "Goa", value: "Goa", code: "30" },
    { label: "Lakshadweep", value: "Lakshadweep", code: "31" },
    { label: "Kerala", value: "Kerala", code: "32" },
    { label: "Tamil Nadu", value: "Tamil Nadu", code: "33" },
    { label: "Puducherry", value: "Puducherry", code: "34" },
    {
      label: "Andaman and Nicobar Islands",
      value: "Andaman and Nicobar Islands",
      code: "35",
    },
    { label: "Telangana", value: "Telangana", code: "36" },
    { label: "Andhra Pradesh", value: "Andhra Pradesh", code: "37" },
  ];

  useEffect(() => {
    const authUser = sessionStorage.getItem("authUser");
    if (authUser) {
      const parsed = JSON.parse(authUser);
      dispatch(getAdminProfile(parsed.data.id));
    }
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      const data = {
        name: user?.name || "",
        email: user?.email || "",
        mobileNo: user?.mobileNo || "",
        address: user?.address || "",

        profilePic: user?.profilePic || "",
        signature: user?.signaturePic || "",
        bankName: user?.bankName || "",
        branchName: user?.branchName || "",
        ifscCode: user?.ifscCode || "",
        accountNo: user?.accountNo || "",
        state: user?.state || "",
        stateCode: user?.stateCode || "",
        saCode: user?.saCode || "",
      };

      setFormData(data);
      setOriginalData(data);
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSignatureCrop = (blob) => {
    const file = new File([blob], "signature.jpg", {
      type: "image/jpeg",
    });

    const previewUrl = URL.createObjectURL(blob);

    setFormData((prev) => ({
      ...prev,
      signature: previewUrl,
      signatureFile: file,
    }));

    setShowSignatureCropper(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const changes = {};
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== originalData[key]) {
        changes[key] = formData[key];
      }
    });

    if (Object.keys(changes).length === 0) {
      toast.info("No changes made.");
      return;
    }

    const authUser = sessionStorage.getItem("authUser");

    if (authUser) {
      const parsed = JSON.parse(authUser);

      const queryPayload = {
        id: parsed.data.id,
        name: formData.name,
        email: formData.email,
        mobileNo: formData.mobileNo,
        address: formData.address,
        bankName: formData.bankName,
        branchName: formData.branchName,
        ifscCode: formData.ifscCode,
        accountNo: formData.accountNo,

        state: formData.state,
        stateCode: formData.stateCode,
        saCode: formData.saCode,
      };

      // const queryPayload = {
      //   id: parsed.data.id,
      // };

      // Object.keys(formData).forEach((key) => {
      //   if (
      //     formData[key] !== "" &&
      //     formData[key] !== null &&
      //     key !== "profilePic" &&
      //     key !== "profilePicFile" &&
      //     key !== "signature" &&
      //     key !== "signatureFile"
      //   ) {
      //     queryPayload[key] = formData[key];
      //   }
      // });

      const imageFormData = new FormData();
      if (formData.profilePicFile) {
        imageFormData.append("adminProfilePic", formData.profilePicFile);
      }

      if (formData.signatureFile) {
        imageFormData.append("signaturePic", formData.signatureFile);
      }

      dispatch(updateAdminProfile(queryPayload, imageFormData))
        .then((res) => {
          dispatch(getAdminProfile(parsed.data.id));
        })
        .catch((err) => {
          toast.error("Update failed. Please try again.");
        });
    }
  };

  const MAX_FILE_SIZE = 100 * 1024;

  document.title = "Admin Profile";

  return (
    <div className="page-content ">
      <Container fluid>
        <Row>
          <Col lg="6" className="mx-auto">
            {error && <Alert color="danger">{error}</Alert>}
            <Card>
              <CardBody className="p-4">
                <div className="border rounded p-4 mb-4 text-center">
                  <div className="position-relative d-inline-block mb-2">
                    {formData.profilePic ? (
                      <img
                        src={formData.profilePic}
                        alt="avatar"
                        className="rounded-circle img-thumbnail"
                        style={{
                          width: "140px",
                          height: "140px",
                          objectFit: "contain",
                          backgroundColor: "#fff",
                        }}
                      />
                    ) : (
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center bg-light border"
                        style={{ width: "140px", height: "140px" }}
                      >
                        <User size={56} className="text-muted" />
                      </div>
                    )}
                    <label
                      htmlFor="profilePicUpload"
                      className="position-absolute bottom-0 end-0 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: "36px",
                        height: "36px",
                        cursor: "pointer",
                      }}
                    >
                      <i className="ri-camera-line text-white"></i>
                    </label>

                    <input
                      type="file"
                      id="profilePicUpload"
                      accept="image/*"
                      hidden
                      // onChange={(e) => {
                      //   const file = e.target.files[0];
                      //   if (!file) return;

                      //   const reader = new FileReader();
                      //   reader.onloadend = () => {
                      //     setFormData((prev) => ({
                      //       ...prev,
                      //       profilePic: reader.result,
                      //       profilePicFile: file,
                      //     }));
                      //   };
                      //   reader.readAsDataURL(file);
                      // }}

                      onChange={(e) => {
                        const file = e.target.files[0];

                        if (!file) return;

                        // File size validation
                        if (file.size > MAX_FILE_SIZE) {
                          toast.error("Image size should be less than 100 KB");
                          e.target.value = "";
                          return;
                        }

                        const reader = new FileReader();

                        reader.onloadend = () => {
                          setFormData((prev) => ({
                            ...prev,
                            profilePic: reader.result,
                            profilePicFile: file,
                          }));
                        };

                        reader.readAsDataURL(file);
                      }}
                    />
                  </div>

                  <h5 className="mb-0">{formData.name}</h5>
                  <small className="text-muted">{formData.email}</small>
                </div>

                <div className="border rounded p-4 mb-4">
                  <h5 className="mb-3">Profile Information</h5>

                  <Form id="profileForm" onSubmit={handleSubmit}>
                    <Row className="g-3">
                      <Col md="6">
                        <FormGroup>
                          <Label>Name</Label>
                          <Input
                            type="text"
                            name="name"
                            value={formData?.name}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <Label>Email</Label>
                          <Input
                            type="email"
                            name="email"
                            value={formData?.email}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <Label>Mobile No</Label>
                          <Input
                            type="text"
                            name="mobileNo"
                            value={formData?.mobileNo}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <Label>Address</Label>
                          <Input
                            type="text"
                            name="address"
                            value={formData?.address}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label>Bank Name</Label>
                          <Input
                            type="text"
                            name="bankName"
                            value={formData.bankName}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <Label>Branch Name</Label>
                          <Input
                            type="text"
                            name="branchName"
                            value={formData.branchName}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <Label>IFS Code</Label>
                          <Input
                            type="text"
                            name="ifscCode"
                            value={formData.ifscCode}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <Label>Account No</Label>
                          <Input
                            type="text"
                            name="accountNo"
                            value={formData.accountNo}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>

                      {/* <Col md="6">
                        <FormGroup>
                          <Label>State</Label>
                          <Input
                            type="text"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col> */}

                      <Col md="6">
                        <FormGroup>
                          <Label>State</Label>

                          <Select
                            options={indianStates}
                            isSearchable
                            placeholder="Select State"
                            value={
                              indianStates.find(
                                (item) => item.value === formData.state,
                              ) || null
                            }
                            onChange={(selected) => {
                              setFormData((prev) => ({
                                ...prev,
                                state: selected?.value || "",
                                stateCode: selected?.code || "",
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>

                      {/* <Col md="6">
                        <FormGroup>
                          <Label>State Code</Label>
                          <Input
                            type="text"
                            name="stateCode"
                            value={formData.stateCode}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col> */}

                      <Col md="6">
                        <FormGroup>
                          <Label>State Code</Label>

                          <Input
                            type="text"
                            name="stateCode"
                            value={formData.stateCode}
                            readOnly
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label>SA Code</Label>
                          <Input
                            type="text"
                            name="saCode"
                            value={formData.saCode}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </div>

                <div className="border rounded p-4">
                  <h5 className="mb-3">Signature</h5>

                  <div
                    className="border rounded p-3 text-center mb-3"
                    style={{ background: "rgb(233, 237, 237)" }}
                  >
                    {formData.signature ? (
                      <img
                        src={formData.signature}
                        alt="signature"
                        style={{
                          maxWidth: "50%",
                          height: "40px",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <small className="text-muted">
                        No signature uploaded
                      </small>
                    )}
                  </div>

                  <Label
                    htmlFor="signatureUpload"
                    className="btn btn-outline-primary btn-sm"
                  >
                    Upload Signature
                  </Label>

                  <Input
                    type="file"
                    id="signatureUpload"
                    accept="image/*"
                    hidden
                    onChange={(e) => {
                      const file = e.target.files[0];
                      e.target.value = "";
                      if (!file) return;

                      const reader = new FileReader();
                      reader.onloadend = () => {
                        setSignatureSrc(reader.result);
                        setShowSignatureCropper(true);
                      };
                      reader.readAsDataURL(file);
                    }}
                  />
                </div>
                <div className="text-center mt-4">
                  <Button
                    color="success"
                    className="px-4"
                    type="submit"
                    form="profileForm"
                  >
                    Update Profile
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {showSignatureCropper && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{ background: "rgba(0,0,0,0.5)", zIndex: 1050 }}
          >
            <div
              className="bg-white p-3 rounded shadow"
              style={{ width: "420px" }}
            >
              <h6 className="mb-2">Crop Signature</h6>
              <ImageCropper
                imageSrc={signatureSrc}
                aspect={3 / 1}
                onCropComplete={handleSignatureCrop}
                onClose={() => setShowSignatureCropper(false)}
              />
            </div>
          </div>
        )}
      </Container>
    </div>
  );
};

export default UserProfile;
